import React from "react";
import { Container } from "react-bootstrap";

function WorkExperience() {
  return (
    <section id="work" className="work-experience-section">
      <Container>
        <h2 className="section-header">
          <span className="purple">WORK </span>EXPERIENCE
        </h2>
        <div className="timeline">
          <div className="timeline-item">
            <div className="timeline-icon"></div>
            <div className="timeline-content">
              <h3>Founding Software Engineer</h3>
              <h4 className="company">Feather App, Inc.</h4>
              <p className="duration">Sep 2025 - Feb 2026</p>
              <ul className="timeline-bullets">
                <li>
                  Architected and shipped a relationship intelligence platform
                  from 0 to 1, spanning ETL pipelines, OpenAI integration,
                  PostgreSQL, Next.js, and AWS CDK infrastructure, launching MVP
                  and onboarding 3 enterprise beta customers in under 5 months.
                </li>
                <li>
                  Designed a 3-layer medallion ETL pipeline processing 100K+
                  records from Gmail, Calendar, and Contacts APIs using 15
                  concurrent BullMQ workers, and Redis-backed queues with AI
                  agents for sentiment analysis, signature parsing, and new
                  contact discovery.
                </li>
                <li>
                  Deployed isolated per-tenant AWS infrastructure via CDK
                  provisioning 80+ CloudFormation resources per customer,
                  including Multi-AZ RDS, ElastiCache Redis, Auto Scaling
                  Groups, internal ALBs with TLS, and AppStream 2.0 for secure
                  desktop access.
                </li>
              </ul>
            </div>
          </div>

          <div className="timeline-item">
            <div className="timeline-icon"></div>
            <div className="timeline-content">
              <h3>Software Engineer</h3>
              <h4 className="company">Moic.co</h4>
              <p className="duration">Jul 2025 - Sep 2025</p>
              <ul className="timeline-bullets">
                <li>
                  Processed 10,000+ daily API requests for automated lead
                  enrichment and cold outreach campaigns by building a TypeScript
                  integration layer connecting Supabase, Clay, and LinkedIn APIs
                  with BullMQ async job processing and OAuth flow management.
                </li>
                <li>
                  Reduced manual social media posting time by 85% across 60+
                  posts for 2 client brands by engineering n8n workflows
                  integrating Perplexity AI for topic discovery, Google Gemini
                  for content generation, and OAuth-secured APIs.
                </li>
              </ul>
            </div>
          </div>

          <div className="timeline-item">
            <div className="timeline-icon"></div>
            <div className="timeline-content">
              <h3>Software Development Engineer</h3>
              <h4 className="company">Brillio, LLC</h4>
              <p className="duration">Sep 2022 - Aug 2023</p>
              <ul className="timeline-bullets">
                <li>
                  Lowered login-related support tickets by 33% for a B2B portal
                  by overhauling the React sign-in form with case-insensitive
                  email validation, a password-strength meter, and a session
                  expiry banner.
                </li>
                <li>
                  Shipped a Spring Boot preferences microservice in 4 weeks with
                  create, read, and update endpoints over MySQL, enabling 100+
                  daily users to persist UI settings like dark mode across
                  sessions and devices.
                </li>
                <li>
                  Resolved 20+ production bugs alongside QA and engineering teams
                  and wrote unit and integration tests covering validation logic
                  and session-banner timing, improving overall release stability.
                </li>
              </ul>
            </div>
          </div>

          <div className="timeline-item">
            <div className="timeline-icon"></div>
            <div className="timeline-content">
              <h3>Research Intern</h3>
              <h4 className="company">
                International Institute of Information Technology Bangalore
              </h4>
              <p className="duration">Jun 2021 - Aug 2021</p>
              <ul className="timeline-bullets">
                <li>
                  Improved traffic flow by 15% across Bangalore neighborhoods by
                  optimizing road network layouts using SUMO and OpenStreetMap
                  simulations.
                </li>
                <li>
                  Increased simulation accuracy by 25% by analyzing vehicular
                  traffic patterns through XML-based layout modifications,
                  producing research-driven visualizations for urban planning
                  decisions.
                </li>
              </ul>
            </div>
          </div>

          <div className="timeline-item">
            <div className="timeline-icon"></div>
            <div className="timeline-content">
              <h3>Software Engineer Intern</h3>
              <h4 className="company">Dokat, Inc.</h4>
              <p className="duration">Aug 2020 - Oct 2020</p>
              <ul className="timeline-bullets">
                <li>
                  Boosted page load speeds by 30% by optimizing React component
                  rendering and frontend performance, improving user satisfaction
                  by 25%.
                </li>
                <li>
                  Resolved 15 critical bugs across the Lisa.ai product alongside
                  QA teams, increasing product reliability by 20%.
                </li>
              </ul>
            </div>
          </div>
        </div>
      </Container>
    </section>
  );
}

export default WorkExperience;
